import { env } from "@/env.mjs"

export function getPrimaryCanonicalUrl(path?: string): string {
  if (process.env.NODE_ENV === "development") {
    return path ?? "/"
  }
  if (!path) return env.NEXT_PUBLIC_PRIMARY_FQDN_DOMAIN
  return new URL(path, env.NEXT_PUBLIC_PRIMARY_FQDN_DOMAIN).toString()
}
